import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { Map } from 'immutable'
import Link from '../Link/index'
import { URL_AI_CHAT } from '../../services/url/constants'

export const MEMBER_HOME_FIRST_TOUCH_AI_PROMPTS_LAYOUT_STRETCH = 'stretch'
export const MEMBER_HOME_FIRST_TOUCH_AI_PROMPTS_LAYOUT_CENTERED = 'centered'

function MemberHomeFirstTouchAiPrompts ({
  auth = Map(),
  staticText = Map(),
  oraclePersonalityId,
  colorSchemePrefix,
  promptKeys,
  layout,
  onPromptClick,
}) {
  const promptRecommendPrefix = staticText.get('aiChatPromptRecommendPrefix') || ''

  const entries = useMemo(() => (
    (Array.isArray(promptKeys) ? promptKeys : [])
      .map((key) => ({ key, label: staticText.get(key) }))
      .filter((row) => row.label != null && String(row.label).trim() !== '')
  ), [promptKeys, staticText])

  if (entries.length === 0) {
    return null
  }

  const layoutClass = layout === MEMBER_HOME_FIRST_TOUCH_AI_PROMPTS_LAYOUT_CENTERED
    ? MEMBER_HOME_FIRST_TOUCH_AI_PROMPTS_LAYOUT_CENTERED
    : MEMBER_HOME_FIRST_TOUCH_AI_PROMPTS_LAYOUT_STRETCH

  return (
    <div
      className={
        `member-home-first-touch__ai-prompts member-home-first-touch__ai-prompts--${layoutClass}`
      }
    >
      {entries.map(({ key, label }) => (
        <Link
          key={key}
          className={`member-home-first-touch__ai-prompt member-home-first-touch__ai-prompt--${colorSchemePrefix}`}
          to={URL_AI_CHAT}
          query={{ prompt: `${promptRecommendPrefix}${label}`, oraclePersonalityId }}
          auth={auth}
          onClick={onPromptClick}
        >
          {label}
        </Link>
      ))}
    </div>
  )
}

MemberHomeFirstTouchAiPrompts.propTypes = {
  auth: ImmutablePropTypes.map,
  staticText: ImmutablePropTypes.map.isRequired,
  oraclePersonalityId: PropTypes.string.isRequired,
  colorSchemePrefix: PropTypes.string.isRequired,
  promptKeys: PropTypes.arrayOf(PropTypes.string).isRequired,
  layout: PropTypes.oneOf([
    MEMBER_HOME_FIRST_TOUCH_AI_PROMPTS_LAYOUT_STRETCH,
    MEMBER_HOME_FIRST_TOUCH_AI_PROMPTS_LAYOUT_CENTERED,
  ]).isRequired,
  onPromptClick: PropTypes.func,
}

MemberHomeFirstTouchAiPrompts.defaultProps = {
  auth: Map(),
  onPromptClick: undefined,
}

export default MemberHomeFirstTouchAiPrompts
